import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Button, Tooltip } from '@totango-app-team/ui-shared-components';
import PropTypes from 'prop-types';

const OauthSignupButtonElement = ({ icon, name, onClick, className }) => (
	<div className="oauth-signup-button-wrapper">
		<Tooltip title={name} placement="bottom">
			<div>
				<Button variant="outlined" onClick={onClick} className={`oauth-signup-button ${className}`}>
					<Grid container>
						<img src={`/img/oauth/${icon}.svg`} alt={name} />
					</Grid>
				</Button>
			</div>
		</Tooltip>
	</div>
);

export default OauthSignupButtonElement;

OauthSignupButtonElement.defaultProps = {
	className: '',
};

OauthSignupButtonElement.propTypes = {
	icon: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	className: PropTypes.string,
};
